import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { Container, Icon, List } from '@pella/sash-framework';
import { CTA, Image } from '../../';

const Footer = ({ className, children, ...other }) => {
	const pageData = useStaticQuery(query).contentstackFooter;

	return (
		<footer
			id='footer'
			className={`footer bg-secondary py-6 text-center md:text-left ${className || ''}`}
			{...other}
		>
			<Container>
				<div className='grid items-center md:grid-cols-[minmax(min-content,max-content)_1fr_minmax(min-content,max-content)]'>
					{pageData?.file?.url && (
						<div className='col-start-1 mb-6 md:mb-0'>
							<Image data={pageData} />
						</div>
					)}

					{pageData?.footer?.[0] && (
						<div className='col-start-1 md:col-end-4 md:mt-8 xl:col-start-2 xl:mt-0'>
							<List
								bullets='none'
								layout='inline'
								className='space-y-4 md:justify-center md:space-x-8 md:space-y-0 xl:justify-end'
							>
								{pageData.footer?.map((cta, index) => (
									<li
										key={index}
										className='max-md:!max-w-12/12 max-md:!flex-12/12'
									>
										<CTA
											data={cta.cta[0]}
											className='group flex flex-row-reverse items-center justify-center border-b border-b-transparent text-base font-bold text-white no-underline hover:border-b-white focus:border-b-white md:py-2 xl:py-0 [&>span]:ml-1 [&>span]:!text-sm'
										/>
									</li>
								))}
							</List>
						</div>
					)}

					{pageData?.branded_content && (
						<div
							className='col-start-1 mb-3 flex flex-wrap items-center text-base text-white md:col-start-2 md:row-start-1 md:mb-0 md:ml-3 md:flex-row xl:col-start-1 xl:col-end-4 xl:row-start-2 xl:ml-0 xl:mt-12 max-md:[&>*]:flex-12/12 [&_figure]:leading-none max-md:[&_figure]:order-first [&_img]:mx-auto [&_img]:block [&_img]:h-4 max-md:[&_img]:mb-1 max-md:[&_img]:block md:[&_img]:ml-3'
							dangerouslySetInnerHTML={{ __html: pageData.branded_content }}
						/>
					)}

					<div className='col-span-full row-start-3 my-7 h-px w-full bg-white/25 md:my-4' />

					{pageData?.copyright && (
						<div className='col-start-1 text-white md:col-end-3'>
							<span className='mr-1 text-xs md:text-sm xl:text-base'>&#169; {new Date().getFullYear()}</span>
							<span
								className='text-xs md:text-sm xl:text-base'
								dangerouslySetInnerHTML={{ __html: pageData.copyright }}
							/>
						</div>
					)}
				</div>
			</Container>
		</footer>
	);
};

Footer.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};

export default Footer;

export const query = graphql`
	{
		contentstackFooter(uid: { eq: "blt559e1db70df03f5f" }) {
			file {
				url
				gatsbyImageData(quality: 90)
			}
			footer {
				cta {
					...CTA
				}
			}
			branded_content
			copyright
		}
	}
`;
